import React from "react";
import { DropAreaDeactivationOverlayContainer } from "@src/components/templates/layouts/drop-area-deactivation-overlay-container/drop-area-deactivation-overlay-container";
import { PillNavigation } from "@src/components/atoms/pill-navigation/pill-navigation";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";

import { useI18N } from "@src/language/language-context";
import { useUserManagementListPillsNav } from "./use-user-management-list-pills-nav";
import {
  UserManagementListActiveRoleEnum,
  UserManagementListActiveViewType,
} from "@src/types/user-management";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

interface GatewayAndSourcesListPillsNavProps {
  activeView: UserManagementListActiveViewType;
}

export const UserManagementListPillsNav = ({
  activeView,
}: GatewayAndSourcesListPillsNavProps) => {
  const i18n = useI18N();
  const authContext = useSelector(
    (state: RootState) => state.yourSlice.authContext,
  );
  const { updateUserManagementListActiveViewHandler } =
    useUserManagementListPillsNav();

  const texts = {
    navTextUsers: i18n("modules.userManagementListPillsNav.navTextUsers"),
    navTextGatewayServiceUsers: i18n(
      "modules.userManagementListPillsNav.navTextGatewayServiceUsers",
    ),
    navTextServiceUsers: i18n(
      "modules.userManagementListPillsNav.navTextServiceUsers",
    ),
  };

  return (
    <DropAreaDeactivationOverlayContainer>
      <FlexRowContainer justifyContent="flex-start">
        <PillNavigation
          options={[
            {
              name: texts.navTextUsers,
              link: UserManagementListActiveRoleEnum.USERS,
              render: true,
            },
            {
              name: texts.navTextGatewayServiceUsers,
              link: UserManagementListActiveRoleEnum.GATEWAY_SERVICE_USERS,
              render:
                authContext &&
                (authContext.permissions.includes(
                  "manage-service-gateway-users",
                ) ||
                  authContext.permissions.includes(
                    "view-service-gateway-users",
                  )),
            },
            {
              name: texts.navTextServiceUsers,
              link: UserManagementListActiveRoleEnum.SERVICE_USERS,
              render:
                authContext &&
                (authContext.permissions.includes("view-service-api-users") ||
                  authContext.permissions.includes("manage-service-api-users")),
            },
          ]}
          activeView={activeView}
          onChangeCallback={updateUserManagementListActiveViewHandler}
        />
      </FlexRowContainer>
    </DropAreaDeactivationOverlayContainer>
  );
};
